<template>
     <div class="card" @click="showCard">

        <div v-if="is_rel" class="logo">
          <img :src="team.shield" />
        </div>
        <div class="content">
            <div v-if="is_rel" class="legend">{{$t('team')}}</div>
            <div class="title">{{team.name}}</div>
            <div class="category" v-if="team.category">{{team.category.name}} | {{team.category.max_age}}</div>
            <div v-if="role && is_rel" class="role" :class="'r' + role.id">{{role.name}}</div>
        </div>
    </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  components: { },
  props: { team: Object, club: Object, event: Object, role: Object, is_rel: Boolean, id_rel: String },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
	  	showCard(){
          var team = {...this.team};
          
          if( team.club == undefined ){
            team.club = {
              id: this.club.id,
              name: this.club.name,
              shield: this.club.shield
            }
          }

          team.event = {
            id: this.event.id,
            name: this.event.name,
            edition: this.event.edition
          }
          this.$card.team( team, this.is_rel, team.club.id );
      }
  },
  created() {
  	var self = this;
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .card {
    padding: 6px;
    border-radius: 3px;
    margin-bottom: 15px;
    overflow: hidden;
    background: url('/img/right-arrow.svg') no-repeat right 10px center #fff;
    background-size: 20px;
    cursor: pointer;
    
    
    .legend {
      font-size: 14px;
      font-weight: lighter;
      text-transform: uppercase;
      color: #acacac;
    }
    .logo {
      height: 90px;
      width: 90px;
      vertical-align: middle;
      float: left;
      padding: 10px;
    }
    .content {
      width: calc( 100% - 90px );
      float: left;
      padding-top: 10px;
    }
    
    .title {
      line-height: 45px;
      margin: 0 auto;
      font-size: 16px !important;
      margin-bottom: 5px;


    }

    .role {
        text-align: left;
        font-size: 14px;


        & .value {
            font-size: 14px;
            text-transform: uppercase;
        }
    }
  }
</style>